import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class ReturnsService {
    private readonly getReturnsURL = `/order/all_returns`;
    private readonly acceptOrRejectReturnURL = `/order/update/return/Id=`;
    // ---------------------------------------------------------------

    getReturns(params: { pageSize: number; pageNumber: number }) {
        return fetchWithRetry(API.get(this.getReturnsURL, { params }));
    }
    acceptOrRejectReturn(returnedItemId: number, accept: boolean) {
        return fetchWithRetry(API.patch(`${this.acceptOrRejectReturnURL}${returnedItemId}/isAccept=${accept}`));
    }
}

export default new ReturnsService();
